import ActivityDetailView from './ActivityDetailView'

export const ActivityContainer: React.FC = () => {
  return <ActivityDetailView />
}
